import { gql } from '@apollo/client';

export default gql`
  query WorkspaceSumary($reportID: UUID!){
    allRpWorkspaceSummaries(condition: {reportId: $reportID}) {
      nodes {
        branch
        reviewsConsidered
        reviewsAnalyzed
        signaturesConsidered
        signaturesAnalyzed
      }
    }
  }
`